import React from "react";
import { Link } from "react-router-dom";

export default function Student12TopMenu({ slug, activeMenu }) {
  console.log("activeMenu", activeMenu);

  return (
    <div className="breadcrumb-bar breadcrumb-bar-info mb-2 sticky-top">
      <div className="container-fluid text-center">
        <div className="d-flex justify-content-between flex-wrap">
          <div>
            <h6>Planning Room</h6>
            <div className="row text-center">
              <div className="d-flex justify-content-between">
                <div>
                  <Link
                    to={`/instructor/instructor-studentschedule/${slug}`}
                    className={
                      activeMenu === "Schedule"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    Schedule
                  </Link>
                </div>

                <div>
                  <Link
                    to={`/instructor/instructor-studenttask/${slug}`}
                    className={
                      activeMenu === "Agenda"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    Agenda
                  </Link>
                </div>

                <div>
                  <Link
                    to={`/instructor/instructor-curriculumtable/${slug}`}
                    className={
                      activeMenu === "Timeline"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    Timeline
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* <div>
            <Link
              to={`/instructor/instructor-studentlesson/${slug}`}
              className={
                activeMenu === "Lessons"
                  ? "tag12 text-decoration-underline text-info-emphasis"
                  : "tag12"
              }
            >
              Courses
            </Link>
          </div> */}
          <div>
            <h6>College</h6>
            <div className="row text-center">
              <div className="d-flex justify-content-between">
                <div>
                  <Link
                    to={`/instructor/college-list/${slug}`}
                    className={
                      activeMenu === "CollegeList"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    {" "}
                    College List
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/instructor/instructor-studentdeadlines/${slug}`}
                    className={
                      activeMenu === "Deadlines"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    Deadlines
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/instructor/instructor-studentfinaid/${slug}`}
                    className={
                      activeMenu === "Financial Aid"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    Fin. Aid
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h6>Writings</h6>
            <div className="row text-center">
              <div className="d-flex justify-content-between">
                <div>
                  <Link
                    to={`/instructor/instructor-studentactivitiesandawards/${slug}`}
                    className={
                      activeMenu === "Activities/Awards"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    Activities/Awards
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/instructor/instructor-studentmainessay/${slug}`}
                    className={
                      activeMenu === "MainEssay"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    Main Essay
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/instructor/instructor-studentsupplementalessay/${slug}`}
                    className={
                      activeMenu === "SuplementalEssay"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    Supplementals
                  </Link>
                </div>

                <div>
                  <Link
                    to={`/instructor/instructor-studentadditionalinfo/${slug}`}
                    className={
                      activeMenu === "AddInfo"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    Additional Info
                  </Link>
                </div>
                <div>
                  <Link
                    to={`/instructor/instructor-studentbragsheet/${slug}`}
                    className={
                      activeMenu === "BragSheet"
                        ? "tag12 text-decoration-underline text-info-emphasis"
                        : "tag12"
                    }
                  >
                    BragSheet
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
